<div class="dialog-container">
  <h2 mat-dialog-title>Bulk Creation Location Tool</h2>

  <!-- PREVIEW PHASE -->
  <ng-container *ngIf="!importDone; else resultSection">
    <div class="table-container">
      <table mat-table [dataSource]="dataSource">
        <!-- Line Number Column -->
        <ng-container matColumnDef="lineNumber">
          <th mat-header-cell *matHeaderCellDef> Line# </th>
          <td mat-cell *matCellDef="let element">
            {{element.lineNumber}}
          </td>
        </ng-container>

        <!-- Dynamic Columns -->
        <ng-container *ngFor="let header of fileHeaders" [matColumnDef]="header">
          <th mat-header-cell *matHeaderCellDef [ngClass]="{'required-header': isRequiredColumn(header)}">
            {{header}}
            <span *ngIf="isRequiredColumn(header)" class="required-asterisk">*</span>
          </th>
          <td mat-cell *matCellDef="let element" [ngClass]="{'required-error': hasRequiredFieldError(element, header)}">
            {{getCellValue(element, header)}}
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
      </table>
    </div>

    <div class="summary-info">
      <p>Total rows: {{totalRows}}</p>
    </div>

    <mat-dialog-actions align="end">
      <button mat-button (click)="onCancel()" [disabled]="isImporting">Cancel</button>
      <button mat-raised-button color="primary" (click)="onConfirm()" [disabled]="isImporting">
        {{ isImporting ? 'Importing...' : 'Continue' }}
      </button>
    </mat-dialog-actions>
  </ng-container>

  <!-- RESULT PHASE -->
  <ng-template #resultSection>
    <div class="result-container">
      <h3>Import result</h3>
      <p *ngIf="importResponse?.message as msg">{{ msg }}</p>
      <p>
        Processed: {{ importResponse?.totalProcessed || 0 }} |
        Success: {{ importResponse?.successCount || 0 }} |
        Errors: {{ importResponse?.errorCount || 0 }}
      </p>

      <mat-dialog-actions align="end">
        <button mat-stroked-button color="primary" (click)="onDownloadResults()" [disabled]="!(importResponse?.results?.length)">
          {{ validationError ? 'Run Diagnostic' : 'Diagnostic Report' }}
        </button>
        <button mat-raised-button color="primary" (click)="onCancel()">Close</button>
      </mat-dialog-actions>
    </div>
  </ng-template>
</div>
